export const LOAD_ORDERS_REQUEST = 'Orders/LOAD_ORDERS_REQUEST';
export const LOAD_ORDERS_SUCCESS = 'Orders/LOAD_ORDERS_SUCCESS';
export const LOAD_ORDERS_ERROR = 'Orders/LOAD_ORDERS_ERROR';

export const PAYMENT_STATE = Object.freeze({
    pending: 'PENDING',
    successful: 'SUCCESSFUL',
});
